<template>
    <div class="push-scheme-container">
        <div class="push-container">
            <div class="container-left">
                <span class="title-description">选择全部语言则默认一个推送内容，选择多个语言则分语言设置推送内容</span>
                <el-form :model="pushContainerForm" v-if="!isAll" ref="form">
                    <el-tabs v-model="languageCurrentName" :stretch="true">
                        <el-tab-pane :name="key" v-for="(item,key) in pushContainerForm" :key="key">
                            <span slot="label">
                                {{key.toUpperCase()}}
                                <em :class="item.title && item.content ? 'language-success': 'language-warning'"></em>
                            </span>
                            <el-form-item label="推送标题" :prop="key + '.title'" :rules="{required: true, message: '请输入推送标题', trigger: 'blur'}">
                                <sub-inputtrim size="small" v-model="item.title" :disabled="isDetail"></sub-inputtrim>
                            </el-form-item>
                            <el-form-item label="推送文案" :prop="key + '.content'" :rules="{required: true, message: '请输入推送文案', trigger: 'blur'}">
                                <sub-inputtrim  type="textarea" size="small" v-model="item.content" :disabled="isDetail"></sub-inputtrim >
                            </el-form-item>
                            <el-form-item label="图片地址" :prop="key + '.imgurl'" :rules="{validator: validatorHttp}">
                                <el-tooltip content="纵向图片宽高比为 3:2；横向图片宽高比为 1:1" placement="top-start">
                                    <el-link  href="https://upload-img.mars-era.cn/" target="_blank"  type="primary">上传图片</el-link>
                                </el-tooltip>
                                <sub-inputtrim  size="small" v-model="item.imgurl" :disabled="isDetail"></sub-inputtrim >
                            </el-form-item>
                        </el-tab-pane>
                    </el-tabs>
                </el-form>

                <el-form :model="pushContainerForm" v-else :rules="pushContainerFormRules" ref="form">
                    <el-form-item label="推送标题" prop="title">
                        <sub-inputtrim  size="small" v-model="pushContainerForm.title" :disabled="isDetail"></sub-inputtrim >
                    </el-form-item>
                    <el-form-item label="推送文案" prop="content">
                        <sub-inputtrim  type="textarea" size="small" v-model="pushContainerForm.content" :disabled="isDetail"></sub-inputtrim >
                    </el-form-item>
                    <el-form-item label="图片地址" prop="imgurl">
                        <el-tooltip content="纵向图片宽高比为 3:2；横向图片宽高比为 1:1" placement="top-start">
                            <el-link  href="https://upload-img.mars-era.cn/" target="_blank"  type="primary">上传图片</el-link>
                        </el-tooltip>
                        <sub-inputtrim  size="small" v-model="pushContainerForm.imgurl" :disabled="isDetail"></sub-inputtrim >
                    </el-form-item>
                </el-form>
                <el-button class="next-button" type="primary" size="small" @click="handlerNext" v-if="!isDetail">下一步</el-button>
            </div>
            <el-tabs v-model="currentModelName" class="container-right">
                <el-tab-pane label="Android" name="android">
                    <img src="../../assets/container-android1.png" width="375" alt="" srcset="">
                    <div class="center">默认效果</div>
                    <img src="../../assets/container-android2.png" width="375" alt="" srcset="">
                    <div class="center">展开效果</div>
                </el-tab-pane>
                <el-tab-pane label="iOS" name="ios">
                    <img src="../../assets/container-ios1.png" width="375" alt="" srcset="">
                    <div class="center">默认效果</div>
                    <img src="../../assets/container-ios2.png" width="375" alt="" srcset="">
                    <div class="center">展开效果</div>
                </el-tab-pane>
            </el-tabs>
        </div>

    </div>
</template>
<script>
import { mapState } from "vuex";
export default {
    name: 'push-scheme',
    props: ['isDetail', 'isCopy', 'activeNumber'],
    data() {
        var  validatorHttp = (rule,value,callback) => {
            let reg = /^https:\/\/([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/;
            if(!reg.test(value) && value){
                callback(new Error("请输入https://开头地址U"));
            }else{
                callback();
            }
        };
        return {
            languageCurrentName: 'en',
            currentModelName: 'android',
            pushContainerForm: {
                title: '',
                content: '',
                imgurl: ''
            },
            pushContainerFormRules: {
                title: [{
                    required: true, message: '请输入推送标题', trigger: 'blur'
                }],
                content: [{
                    required: true, message: '请输入推送文案', trigger: 'blur'
                }],
                imgurl: [{
                   validator:validatorHttp
                }]
            },
            isAll: true,
            langs: [],
            validatorHttp: validatorHttp
        }
    },
    computed: {
        ...mapState('pushPushPlanOperate', ['data'])
    },
    watch: {
        data: {
            handler() {
                this.init();
            },
            immediate: true
        },
        activeNumber(num)  {
            if(num === 2) {
                this.init();
            }
        }
    },
    methods: {
        handlerNext() {
            this.$refs['form'].validate((valid, obj) => {
                if(Object.keys(obj).length && Object.keys(obj)[0].indexOf('.') > -1) {
                    this.languageCurrentName = Object.keys(obj)[0].split('.')[0];
                }
                if(valid) {
                    this.$emit('submit',{
                        contents: this.pushContainerForm
                    } , 2)
                }
            })
        },
        init() {
            if(typeof this.data.conditions.lang !== 'undefined' && typeof this.data.conditions.lang === 'string'){
                this.langs = this.data.conditions.lang.split(',');
            }else if(typeof this.data.conditions.lang) {
                this.langs = this.data.conditions.lang;
            }
            this.initLanguageOptionParams();
        },
        initLanguageOptionParams() {
            this.pushContainerForm = {};
            if(Array.isArray(this.langs) && this.langs.length) {
                this.langs.map(item => {
                    if(this.data.contents[item]) {
                        this.pushContainerForm[item] = this.data.contents[item];
                    }else {
                        this.$set(this.pushContainerForm, item, {
                            title: '',
                            content: '',
                            imgurl: ''
                        })
                    }
                })
                this.languageCurrentName = this.langs[0];
                this.isAll = false;
            }else {
                if(Object.keys(this.data.contents).length) {
                    this.pushContainerForm = this.data.contents;
                }else {
                    this.pushContainerForm =  {
                        title: '',
                        content: '',
                        imgurl: ''
                    };
                }
                this.isAll = true;
            }
        }
    }
}
</script>
<style lang="scss" >
.push-container{
    display: flex;
    justify-content: space-between;
    .container-left{
        width: 500px;
    }
    .container-right{
        width: 375px;
        .center {
            text-align: center;
            margin: 8px 0 18px;
        }
    }
    .el-tabs__content{
        overflow: visible;
    }
    .el-tabs__item{
        padding: 0!important;
        width: 70px;
        text-align: center;
    }
    .el-tabs__header{
        width: 500px;
    }
    .language-success, .language-warning{
        width: 5px;
        height: 5px;
        border-radius: 50%;
        display: inline-block;
        margin-bottom: 7px;
    }
    .language-success{
        background: #67C23A;
    }
    .language-warning{
        background: #F56C6C;
    }
    .next-button{
        margin-top: 10px;
    }
    .el-link.el-link--primary{
        float: right;
    }
}

</style>



// WEBPACK FOOTER //
// website/subComponents/push/PushContainer.vue